import * as React from "react";
function SvgEyedropper(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M37.5 4.5C36.3 1 32.5-.8 29 .4c-1.7.6-3 1.8-3.8 3.4l-5.3 10.8-3.6-1.7-1.2 2.4 3.6 1.7-7.6 15.6c-1.4 2.8-.6 6.3 1.9 8.2l-2.9 6.1 2.4 1.2 2.9-6.1c.5.1 1.1.2 1.7.2 2.6 0 4.9-1.5 6-3.7l7.6-15.6 3.6 1.7 1.1-2.4-3.6-1.8 5.3-10.8c.8-1.6 1-3.4.4-5.1zM20.8 37.2c-.9 2-3.3 2.9-5.3 2-2-.9-2.9-3.3-2-5.3 0-.1.1-.1.1-.2l7.6-15.6 7.2 3.5-7.6 15.6z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgEyedropper);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
